import React from 'react';
import './App.css';
import { Routes, Route, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Sidebar from './components/sidebar';
import Login from './pages/login';
import User from './pages/user';
import ServiceUser from './pages/service-user'
import Comapny from './pages/company';
import CompanyMachine from './pages/company/machine'
import CompanyMachineInstance from './pages/company/machine/instance'
import CompanyCrops from './pages/company/crop'
import CompanyUser from './pages/company/user'
import CompanyLocations from './pages/company/location'
import CompanyConfig from './pages/company/config'
import CompanyConfigAction from './pages/company/config/configAction'
import Role from './pages/role';
import Crop from './pages/crop';
import CropConfig from './pages/crop/config'
import CropConfigAction from './pages/crop/config/configAction'
import CompanyMetadata from './pages/company/metadata'
import Class from './pages/class'
import Variety from './pages/crop/variety'
import Machine from './pages/machine';
import Instance from './pages/machine/instance'
import Version from './pages/machine/version'
import Calibration from './pages/calibration'
import AuthGuard from './routes/AuthGuard';

const App: React.FC = () => {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
        {/* Protected Routes */}
        <Route element={<AuthGuard redirectPath="/" />}>
          <Route
            element={
              <Sidebar>
                <Outlet />
              </Sidebar>
            }
          >
            <Route path="/users" element={<User />} />
            <Route path="/service_users" element={<ServiceUser />} />
            <Route path="/company" element={<Comapny />} />
            <Route path="/company/:company_id/users" element={<CompanyUser />} />
            <Route path="/company/:company_id/machines" element={<CompanyMachine />} />
            <Route path="/company/:company_id/machines/:company_machine_id" element={<CompanyMachineInstance />} />
            <Route path="/company/:company_id/crops" element={<CompanyCrops />} />
            <Route path="/company/:company_id/locations" element={<CompanyLocations />} />
            <Route path="/company/:company_id/:company_name/company_config" element={<CompanyConfig />} />
            <Route path="/company/:company_id/:company_name/:crop_name?/:variety_name?/:machine_name?/company_config/:action/:company_config_id?" element={<CompanyConfigAction />} />
            <Route path="/company/:company_id/metadata" element={<CompanyMetadata />} />
            <Route path="/crops" element={<Crop />} />
            <Route path="/crops/:crop_id/:crop_name/crop_config" element={<CropConfig />} />
            <Route path="/crops/:crop_id/:crop_name/:variety_name?/:machine_name?/crop_config/:action/:crop_config_id?" element={<CropConfigAction />} />
            <Route path="/classes" element={<Class />} />
            <Route path="/crops/:crop_id/varieties" element={<Variety />} />
            <Route path="/machines" element={<Machine />} />
            <Route path="/machines/:machine_id/versions/:version_id/instances" element={<Instance />} />
            <Route path="/machines/:machine_id/versions" element={<Version />} />
            <Route path="/roles" element={<Role />} />
            <Route path="/calibration" element={<Calibration />} />
            <Route path="*" element={<h1>404 Not Found</h1>} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default App;
